import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Gets a URL to download a given file
 * @param fileurl The file's URL
 * @returns An object containing the URL of the file being requested
 */
export function getInstructionFileUrl(this: unknown, fileurl: string) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${miEnvironment.resolve(this).instructionFileurlUrl}/${fileurl}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        url: z.string(),
      })
    )
  );
}
